import {currentMousePointerId} from "../mouse/current-mouse-pointer-id";

export const currentPenOrTouchPointerId = currentMousePointerId + 1;
